import Menu from './Compartido/Menu.jsx';
import TextosPreautorizar from './Preautorizar/TextosPreautorizar.jsx';
import Footer from './Compartido/Footer.jsx';

const Preautorizar = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosPreautorizar
                datoscliente={props.datoscliente}
                datospropiedad={props.datospropiedad}
                reserva={props.reserva}
                fianza={props.fianza}
                config={props.config}
                tpvs={props.tpvs}
                lang={props.lang}
                ruta={props.ruta}
                moneda={props.moneda}
                params={props.params}
                version={props.version}
                signature={props.signature}
                urlpago={props.urlpago}
                colorboton={props.colorboton}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}
export default Preautorizar;
